import { destinationMapAPIClient } from '@/scopes/products/infrastructure/api/destination-map';
import { useQuery } from '@tanstack/react-query';
import { useCMSPageField } from '@/cms/fields';

export function useDestinationMapData() {
  const accommodationId = useCMSPageField('PDP.id');
  const { data, isLoading } = useQuery({
    queryFn: () => {
      return destinationMapAPIClient.getNearbyAccos({ currentAccoId: accommodationId });
    },
    queryKey: ['nearby-accos', accommodationId],
  });
  return {
    nearbyAccos: data?.accommodations,
    isLoading,
  };
}

export function useAccoDetailsById(accoId: string) {
  const { data, isLoading } = useQuery({
    queryFn: () => {
      return destinationMapAPIClient.getAccoDetails({ accoId });
    },
    queryKey: ['acco-details', accoId],
  });
  return {
    accoDetails: data,
    isLoading,
  };
}
